import Title from "../components/Title";
import BasicLayout from "../layouts/Basic";
import Responsive from "../layouts/Responsive";
// import { gsap } from "gsap";
import { gsap } from "gsap/dist/gsap";
import React, { useRef, useEffect } from "react";
import Pp from "../sketches/Pp";

const Summer = () => {
  useEffect(() => {
    // gsap.fromTo(
    //   ".canvas-wrapper",
    //   {
    //     duration: 3,
    //     ease: "power1",
    //     filter:"blur(30px)",
    //   },
    //   {
    //     duration: 3,
    //     ease: "power1",
    //     filter:"blur(2px)",
    //     repeat: -1, // 무한반복
    //     yoyo: true
    //   }
    // );
  });

  return (
    <>
      <Responsive />
      <div className="book-wrapper">
        <div className="left-con">
          {/* <Title /> */}
          <div className="contents-wrapper">
            <div className="canvas-wrapper">
              <Pp />
              <div className="summer-text"></div>
            </div>
            <div className="element-wrapper">
              <div className="clip"></div>
            </div>
          </div>
        </div>
        <BasicLayout />
      </div>
    </>
  );
};

export default Summer;
